import styled, { css } from 'styled-components'

type CasePageContainerProps = {
  color: string
  elementVisible: boolean
}
export const CasePageContainer = styled.div<CasePageContainerProps>`
  display: flex;
  width: 100%;
  max-width: 1170px;
  gap: 32px;
  justify-content: space-between;
  margin-top: 24px;

  .left-container {
    width: 100%;
    max-width: 569px;
    display: flex;
    flex-direction: column;
    gap: 32px;
  }

  .right-container {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 32px;

    .topic-container {
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: 8px;
      position: relative;

      .subtopic-title {
        text-align: right;
      }
      .topic-title {
        position: relative;
        margin-bottom: 8px;
        text-align: right;
        font-weight: 700;
        .bar {
          width: 0;
          border: 2px solid ${(props) => props.color};
          position: absolute;
          right: 0;
          bottom: -0.5rem;
          transition: width 0.8s ease-in;

          ${({ elementVisible }) =>
            elementVisible &&
            css`
              width: 100%;
            `}
        }
      }
    }
  }

  @media (max-width: 700px) {
    flex-direction: column;
    gap: 36px;

    .left-container img {
      width: 100%;
    }

    .right-container {
      align-items: flex-start;
      .topic-container {
        max-width: 320px;
        .subtopic-title,
        .topic-title {
          text-align: left;
          .bar {
            left: 0;
          }
        }
      }
    }
  }
`
